import Axios from '@/axios'

// 查询设备
export const getDevices = params => {
  return Axios({
    url: '/face/web/device/index_device',
    method: 'GET',
    type: 'json',
    params
  })
}
// 新增设备
export const createDevice = data => {
  return Axios({
    url: '/face/web/device/create_device',
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改设备
export const modifyDevice = data => {
  return Axios({
    url: '/face/web/device/update_device/' + data.id,
    method: 'POST',
    type: 'json',
    data
  })
}
// 删除设备
export const deleteDevice = data => {
  return Axios({
    url: '/face/web/device/delete_device/' + data.id,
    method: 'POST',
    type: 'json',
    data
  })
}
// 查询设备详情
export const getDeviceDetail = params => {
  return Axios({
    url: '/face/web/device/show_device/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}
// 查询设备配置
export const getDeviceConfig = params => {
  return Axios({
    url: '/face/web/device/show_device_config/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}
// 修改设备配置
export const modifyDeviceConfig = (data, id) => {
  return Axios({
    url: '/face/web/device/update_device_config/' + id,
    method: 'POST',
    type: 'json',
    data
  })
}
// 发送远程控制命令
export const sendRemoteCommand = data => {
  return Axios({
    url: '/face/web/device/send_command',
    method: 'POST',
    type: 'json',
    data
  })
}
// 设置是否为访客签到门禁机
export const setSignInDevice = data => {
  return Axios({
    url: '/face/web/device/update_is_visitor_sign_ac_device',
    method: 'POST',
    type: 'json',
    data
  })
}

export const GetDeviceListForOrder = data => {
  return Axios({
    url: '/face/web/device/index_device_for_order',
    method: 'POST',
    type: 'json',
    data
  })
}

export const GetDeviceListForCloudExpired = () => {
  return Axios({
    url: '/face/web/device/show_cloud_platform_near_expired_device',
    method: 'POST',
    type: 'json'
  })
}
